<template lang="html">
  <article class="fc-m-container">
    <h2>Team details</h2>
    <!-- trades message -->
    <trades-available
      v-if="isOwner && team.available_trades"
      :league="league.id"
    ></trades-available>
    <!-- team details -->
    <table class="table table-sm table-borderless fc-m-team">
      <tbody>
        <tr>
          <td class="h4">Team name:</td>
          <td class="h3">{{ team.name }}</td>
        </tr>
        <tr>
          <td class="h4">Total points:</td>
          <td>{{ displayPoints() }}</td>
        </tr>
        <tr>
          <td class="h4">Owner:</td>
          <td>
            <div v-for="owner in team.owners" :key="owner.id">
              {{ owner.username }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="h4">League:</td>
          <td>{{ league.name }}</td>
        </tr>
      </tbody>
    </table>
    <!-- edit button -->
    <p v-if="isOwner || $store.state.auth.account_type == 'educator'">
      <router-link
        class="btn btn-secondary"
        :to="`/leagues/${league.id}/teams/${team.id}/edit/`"
        >Edit Settings</router-link
      >
    </p>
  </article>
</template>

<script>
import TradesAvailable from "@/views/components/TradesAvailable";

export default {
  name: "TeamDetail",
  components: {
    tradesAvailable: TradesAvailable
  },
  props: {
    league: { type: Object },
    team: { type: Object },
    isOwner: { type: Boolean }
  },
  methods: {
    displayPoints: function() {
      return this.league.draft_status == "Complete" &&
        this.team.total_points != null
        ? this.team.total_points
        : 0;
    }
  }
};
</script>

<style lang="css" scoped></style>
